import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const getPaymentMethods = async ({ queryKey }: JsonDataItem) => {
  const serviceType = `service_type=${queryKey[1].serviceType}`;
  const jobServiceType = `&job_service_type=${queryKey[1].jobServiceType}`;
  const customerId = queryKey[1].customerId ? `&customer_id=${queryKey[1].customerId}` : '';

  const { data } = await baseQuery(`payment-methods?${serviceType}${jobServiceType}${customerId}`);

  return data;
};
